import { Directive } from '@angular/core';

@Directive({
  selector: '[wzAsyncContentError]',
  standalone: false,
})
export class AsyncContentErrorDirective {
  constructor() {}
}
